module.exports = __webpack_public_path__ + "fonts/Inter-100-vietnamese5.9df1755.woff2";